import { store } from './store/store'
import axios from 'axios'
import addWord from './components/addWord.vue'
import searchRhyme from './components/searchRhyme.vue'
import getWordRhyme from './components/getWordRhyme.vue'
import getWord from './components/getWord.vue'
import Login from './components/Login.vue'
import Fee from './components/Fee.vue'


export const routes = [{
        path: '/getWordRhyme/:id',
        beforeEnter: async(to, from, next) => {
            let res = await axios.get(`http://185.81.96.220/checkToken?api_token=${store.getters.token}`)
            if (res.status == 200) {

                return next()
            }
            next('Login')

        },
        component: getWordRhyme,


    },

    {
        path: '/searchRhyme',
        beforeEnter: async(to, from, next) => {
            let res = await axios.get(`http://185.81.96.220/checkToken?api_token=${store.getters.token}`)
            if (res.status == 200) {

                return next()
            }
            next('Login')

        },
        component: searchRhyme,


    },
    {
        path: '/addWord',
        beforeEnter: async(to, from, next) => {
            let res = await axios.get(`http://185.81.96.220/checkToken?api_token=${store.getters.token}`)
            if (res.status == 200) {

                return next()
            }
            next('Login')

        },
        component: addWord,


    },
    {
        path: '/getWord',
        beforeEnter: async(to, from, next) => {
            let res = await axios.get(`http://185.81.96.220/checkToken?api_token=${store.getters.token}`)
            if (res.status == 200) {

                return next()
            }
            next('Login')

        },
        component: getWord,


    },
    { path: '/Login', component: Login, name: 'Login' },
    { path: '/Fee', component: Fee, name: 'Fee' },

]